// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { containerStyles } from "@awc/App/Widgets/Container/Container";
import { css } from "styled-components";

containerStyles.wrapper = {
    css: css`
        padding: 18px 12px 12px;

        ${({ showBoxShadow }: any) => {
            if (showBoxShadow) {
                return css`
                    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.4);
                `;
            }
        }}
        ${({ shadowColor }: any) => {
            if (shadowColor) {
                return css`
                    border-top: 4px solid ${shadowColor};
                `;
            }
        }}
    `,
};
